// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__W2NuN","sendOtp":"AuthorizeToLogin_sendOtp__1Oy2V"};